import React from "react";
import Head from "./Head";
import Body from "./Body";
import NoAccountFoundLoader from "../../../../../../assets/images/noaccountsloaderbc.gif";
import { t } from "../../../../../utils/i18n";

const Table = ({ wallets, loading, deleteWallet }) => (
  <div>
    <div className="onlinewalletspage-table">
      <table className="_table">
        <Head />
        {loading ? (
          <p className="onlinewalletspage-noaccount-loader">
            <img src={NoAccountFoundLoader} width="500" alt={t("p2p.common.no_accounts_found")} />
          </p>
        ) : (
          <Body wallets={wallets} deleteWallet={deleteWallet} />
        )}
      </table>
    </div>
  </div>
);

export default Table;
